export function assertState(state, ...expectedTypes) {
    if (!expectedTypes.includes(state.type)) {
        throw new Error(`Invalid state ${state.type} (expected one of: ${expectedTypes})`);
    }
}
